import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { currentUser, userProfile, loading } = useAuth();
  
  if (loading) return null;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // REDIRECT SUSPENDED USERS
  if (userProfile && (userProfile.status === 'suspended' || userProfile.status === 'banned' || userProfile.status === 'blocked')) {
    // Only allow access to /suspended and /report
    const path = window.location.pathname;
    if (path !== '/suspended' && path !== '/report') {
      return <Navigate to="/suspended" replace />;
    }
  }
  
  return children;
}

export default ProtectedRoute;
